module.exports = __webpack_public_path__ + "img/record.d85b5494.png";